module.exports = __webpack_public_path__ + "dashboard/img/pl.a90243943c32eb1d410185b51b7e5517.svg";